import {useState, useCallback} from 'react'
import settings from '../machineSettingsData'

function useErrorCodes() {
    const [errorCodes, setErrorCodes] = useState(() => updateCodeOrder())
    const [currentError, setCurrentError] = useState(errorCodes[0])
    const [currentAnswer, setCurrentAnswer] = useState([])
    const [variation, setVariation] = useState(1)
    
    function shuffleErrorCodes() {
        const newArr = updateCodeOrder()
        setErrorCodes(newArr)
        setCurrentError(newArr[0])
    }
    
    function updateCodeOrder() {
        const errorArr = [...settings.errorCodeData]
        const shuffledArr = []
        while (errorArr.length > 0) {
            const randomNum = Math.floor(Math.random() * errorArr.length)
            shuffledArr.push(errorArr[randomNum])
            errorArr.splice(randomNum, 1)
        }
        return shuffledArr
    }
    
    function nextErrorCode() {
        let errorIndex = errorCodes.findIndex(code => currentError.name === code.name)
        errorIndex = errorIndex < errorCodes.length - 1 ? errorIndex + 1 : 0
        const nextCode = errorCodes[errorIndex]
        const randomVari = Math.floor(Math.random() * nextCode.answer.length)
        setVariation(randomVari)
        setCurrentError(nextCode)
    }
    
    const updateCurrentAnswer = useCallback(() => {
        const errorCode = errorCodes.find(code => currentError.name === code.name)
        setCurrentAnswer(errorCode.answer[variation])
    }, [currentError, errorCodes, variation])
        
    return {
        currentError,
        variation, 
        shuffleErrorCodes, 
        nextErrorCode,
        currentAnswer, 
        updateCurrentAnswer
    }
}

export default useErrorCodes